import { gsap } from 'gsap';

export default class TiltEffect {
  constructor(element, options = {}) {
    this.element = element;

    this.options = {
      maxTilt: 12, // rotation max en degrés
      scale: 1.05, // zoom au survol
      perspective: 900, // plus petit = effet 3D plus prononcé
      speed: 0.4, // durée de suivi du curseur (s)
      resetDuration: 0.9,
      ...options,
    };

    this.layers = [...element.querySelectorAll('[data-tilt-depth]')];

    this.onEnter = this.onEnter.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onLeave = this.onLeave.bind(this);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.element.classList.add('tilt');
    gsap.set(this.element, { transformPerspective: this.options.perspective });

    // quickTo = tweens réutilisables, très performants pour suivre un curseur
    const { speed } = this.options;
    const opts = { duration: speed, ease: 'power3.out' };
    this.rotX = gsap.quickTo(this.element, 'rotationX', opts);
    this.rotY = gsap.quickTo(this.element, 'rotationY', opts);

    this.element.addEventListener('pointerenter', this.onEnter);
    this.element.addEventListener('pointermove', this.onMove);
    this.element.addEventListener('pointerleave', this.onLeave);
  }

  onEnter(e) {
    if (e.pointerType !== 'mouse') return;

    gsap.to(this.element, {
      scale: this.options.scale,
      duration: 0.4,
      ease: 'power3.out',
      overwrite: 'auto',
    });

    // Fait ressortir les couches (z en px selon data-tilt-depth)
    this.layers.forEach((layer) => {
      gsap.to(layer, {
        z: parseFloat(layer.dataset.tiltDepth) || 30,
        duration: 0.5,
        ease: 'power3.out',
      });
    });
  }

  onMove(e) {
    if (e.pointerType !== 'mouse') return;

    const rect = this.element.getBoundingClientRect();
    // Position du curseur de -0.5 (bord gauche/haut) à 0.5 (bord droit/bas)
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;

    this.rotY(px * this.options.maxTilt * 2);
    this.rotX(-py * this.options.maxTilt * 2);
  }

  onLeave(e) {
    if (e.pointerType !== 'mouse') return;

    this.rotX(0);
    this.rotY(0);

    gsap.to(this.element, {
      scale: 1,
      duration: this.options.resetDuration,
      ease: 'elastic.out(1, 0.6)',
      overwrite: 'auto',
    });

    this.layers.forEach((layer) => {
      gsap.to(layer, { z: 0, duration: 0.6, ease: 'power3.out' });
    });
  }

  destroy() {
    this.element.removeEventListener('pointerenter', this.onEnter);
    this.element.removeEventListener('pointermove', this.onMove);
    this.element.removeEventListener('pointerleave', this.onLeave);
    gsap.killTweensOf([this.element, ...this.layers]);
    gsap.set([this.element, ...this.layers], { clearProps: 'all' });
  }
}

document.querySelectorAll('[data-tilt]').forEach((el) => new TiltEffect(el));
